export const FEATURE_ROUTE = '/features';
